import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { UserService } from "src/app/core/services/user.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-verify-email",
  templateUrl: "./verify-email.component.html",
  styleUrls: ["./verify-email.component.scss"],
})
export class VerifyEmailComponent implements OnInit {
  
  isLoading: boolean = false;


  constructor(private userService: UserService, private router: Router, private fb: FormBuilder) {}

  ngOnInit(): void {

  }

  navigateLogin(){
    this.router.navigate(['/login'])
  }

}

